<style lang="scss" scoped="bottom">
  @import "./style.scss"
</style>

<template>
    <div class="bottom">
    	<p> 苏州亿数腾云科技有限公司 版权所有 [苏ICP备18063955号-1] </p>
    </div>
</template>

<script>
import script from './script.js'
export default script
</script>



// WEBPACK FOOTER //
// src/views/common/bottom/index.vue